import { c as _c } from "react/compiler-runtime";
import { Favourites as SharedFavourites } from "@catchy/ui";
import { getEffectiveStopType } from "@/lib/stopTypes";
const resolveStopType = ({
  stop_id,
  stop_type,
  type
}) => getEffectiveStopType({
  stop_id,
  stop_type
}, type);
export default function Favourites(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SharedFavourites {...props} filterType="all" resolveStopType={resolveStopType} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}